import { tv } from '~/utils/tv'

export const CardInformativeTitleVariants = tv({
  base: `
    text-text-neutral font-rdmodern font-bold text-threeandhalfpulse line-clamp-1
  `,
  variants: {},
})
